export const trackPageView = (pathname: string) => {
  // @ts-ignore
  gtag("set", "page_path", pathname);
  // @ts-ignore
  gtag("event", "page_view");
};
